import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import CalendarApi from '../server/CalendarApi';


function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);

export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.CALENDAR_LIST);
        const handleError = createErrorHandler(ActionTypes.CALENDAR_LIST_ERROR);
        
        return CalendarApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    save: function(calendar) {
        const handleSuccess = createSuccessHandler(ActionTypes.CALENDAR_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.CALENDAR_SAVE_ERROR);
        
        return CalendarApi.save(calendar)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    delete: function(calendarId) {
        const handleSuccess = createSuccessHandler(ActionTypes.CALENDAR_DELETE);
        const handleError = createErrorHandler(ActionTypes.CALENDAR_DELETE_ERROR);
        
        return CalendarApi.delete(calendarId)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    getEventsForCalendar: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.CALENDAR_EVENT_LIST);
        const handleError = createErrorHandler(ActionTypes.CALENDAR_EVENT_LIST_ERROR);

        return CalendarApi.getEventsForCalendar(id)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    }
};
